import React from 'react';
import { formatTime } from '../../../../services/formatting';
import { useParams } from '../../../../services/routing/useRouteInfo';
import { Delete, Edit, Import } from '../../../shared/actions/actionButtons';
import { ViewLayout } from '../../../shared/cardLayouts/viewLayout';
import { AutoSizeCard } from '../../../shared/cards/autoSizeCard';
import { StatCard } from '../../../shared/cards/statCard';
import { UserPopoutCard } from '../../../shared/cards/userPopoutCard';
import { LoadText } from '../../../shared/load/loadText';
import { Telephone } from '../../../shared/links/telephone';
import { View } from '../../../shared/view/view';
import { ZipcodeList } from '../zipcodes/zipcodeList';
import { NoteCard } from '../../../shared/cards/noteCard';
import { pathJoin } from '../../../../services/api';
import { useHasPermission } from '../../../../services/auth/auth';
import { ReactComponent as WarningIcon } from '../../../../assets/icons/warning.svg';
import { IconHeading } from '../../../shared/cards/iconHeading';
import { BRANCH, USER, ZIPCODE } from '../../../../permissions';


import styles from './branchView.module.css';


export const BranchView = () => {

    let { id } = useParams();
    const canReadZipcode = useHasPermission([ZIPCODE.READ]);
    const canReadUser = useHasPermission([USER.READ]);

    return <View
        id={parseInt(id ?? '')}
        resourceName='Branch'
        nameFunction={r => r?.name}
        restEndpoint='locations/branches'
        listUrl='locations/branches'
        readPermissions={[BRANCH.READ]}
        writePermissions={[BRANCH.WRITE]}
        actions={[Edit, Delete, Import]}
    >
        {
            ({ loading, data, canWrite, canRead, refreshData }) => <ViewLayout>
                {data.note ? <NoteCard
                    columns={3}
                    restEndpoint={pathJoin('locations', 'branches', id)}
                    refreshData={refreshData}
                    title='Branch Note'
                    editButton={canWrite}
                    deleteButton={canWrite}
                >{data.note}</NoteCard> : ''}
                <StatCard
                    title={<>
                    Branch Info
                    </>}
                    stats={{
                            'Branch Name': loading ? <LoadText /> : data.name ?? 'None',
                            'Zip Codes': loading ? <LoadText /> : data.zipcodeCount,
                            'Address': loading ? <LoadText /> : data.address ?? 'None',
                            'Walkin Hours': loading ? <LoadText /> : formatTime(data.walkinStart) + ' to ' + formatTime(data.walkinEnd),
                            'Phone': loading ? <LoadText /> : (data.phone) ? <Telephone weight='bold' number={(data.phone)} /> : 'None',
                            'Brightree Task Id': loading ? <LoadText /> : data.brightreeTaskId ?? 'None',
                        }}
                />

                <AutoSizeCard
                    columns={2}
                >
                    <IconHeading icon={<WarningIcon />} iconBackground={false}>
                        Branch Exceptions
                    </IconHeading>
                    <div className={styles.BranchExceptions}>{loading ? <><LoadText /><br /><LoadText /><br /><LoadText /></> : (data.exceptions ?? <i>No Exceptions</i>)}</div>
                </AutoSizeCard>

                {canReadZipcode && <AutoSizeCard
                    columns={2}
                >
                    <h1>Zip Codes</h1>
                    <ZipcodeList
                        scope={id ? parseInt(id.toString()) : null}
                        maxResults={10}
                    />
                </AutoSizeCard>}

                <UserPopoutCard
                    data={{
                        displayName: loading ? <LoadText /> : data.manager?.displayName ?? 'None',
                        id: data.manager?.id
                    }}
                    subtitle='Manager'
                    action={canReadUser ? undefined : <></>}
                />
            </ViewLayout>
        }
    </View>
}